import {
  DialogFooter,
  DialogHeader,
  DialogClose,
  DialogTitle,
  Typography,
  Loading,
  Stepper,
  Button,
} from '@ui/components';
import { getSubscriptionDiff } from '@pages/subscription/utils';
import { SubscriptionFeaturesList } from '@shared/components';
import { useSubscriptions } from '@pages/subscription/hooks';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';

interface DowngradeModalStep1Props {
  subscriptionCode: string | null;
  onConfirm: () => void;
}

export const DowngradeModalStep1: FC<DowngradeModalStep1Props> = ({
  subscriptionCode,
  onConfirm,
}) => {
  const { t } = useTranslation();

  const { subscriptions, initialData } = useSubscriptions();

  const selectedSubscription = initialData?.items.find(
    (subscription) => subscription.code === subscriptions?.selectedSubscriptionCode,
  );

  const subscriptionToDowngrade = initialData?.items.find(
    (subscription) => subscription.code === subscriptionCode,
  );

  if (!selectedSubscription || !subscriptionToDowngrade) return <Loading />;

  const diff = getSubscriptionDiff(selectedSubscription, subscriptionToDowngrade);

  return (
    <>
      <DialogHeader>
        <DialogTitle>{t('SUBSCRIPTIONS.DOWNGRADE_MODAL.DO_YOU_WANT_TO_DOWNGRADE')}</DialogTitle>
      </DialogHeader>
      <div className="px-4 pt-4">
        <Stepper className="mb-4" activeStep={0} steps={2} />

        <Typography variant="labelLargeBook">
          {t('SUBSCRIPTIONS.DOWNGRADE_MODAL.BY_CHANGING_PLAN_DESCRIPTION', {
            currentPlan: selectedSubscription.name,
            newPlan: subscriptionToDowngrade.name,
          })}
        </Typography>

        <SubscriptionFeaturesList className="mt-4" features={diff} />

        <Typography className="mt-6 text-weak" variant="labelSmallBook">
          {t('SUBSCRIPTIONS.MODAL_DESCRIPTION')}
        </Typography>
      </div>
      <DialogFooter>
        <DialogClose asChild>
          <Button variant="tertiary" size="large" wide>
            {t('SUBSCRIPTIONS.DOWNGRADE_MODAL.CANCEL')}
          </Button>
        </DialogClose>
        <Button onClick={onConfirm} size="large" wide>
          {t('SUBSCRIPTIONS.DOWNGRADE_MODAL.CONFIRM')}
        </Button>
      </DialogFooter>
    </>
  );
};
